// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { NoticeBar } from 'vue-easy-notice-bar'
 
Vue.use(NoticeBar);

import 'vue-beauty/package/style/vue-beauty.min.css'
import vueBeauty from 'vue-beauty'
Vue.use(vueBeauty)

import 'xe-utils'
import VXETable  from 'vxe-table'
import 'vxe-table/lib/index.css'
Vue.use(VXETable)

VXETable.formats.mixin({
  // 格式化金额
  formatNumber ({ cellValue }) {
    var value = cellValue;
    var b = false;
		if (value == null || value == "") return "0"; 
		value = value.toString();
		if(value.indexOf('-') != -1){
			b= true;
			value = value.substring(1,value.length);
		}
		if (/^\-?[0-9]+(.[0-9]+)?$/.test(value)){
			value = value.toString().replace(/^(\d*)$/, "$1."); 
			value = (value + "00").replace(/(\d*\.\d\d)\d*/, "$1"); 
			value = value.replace(".", ","); 
			var re = /(\d)(\d{3},)/; 
			while (re.test(value)) 
				value = value.replace(re, "$1,$2"); 
			value = value.replace(/,(\d\d)$/, ".$1"); 
		}
		if(b){
			value = "-"+value;
		}
		return value;
  },
})

//使用font-awesome 图标
import 'font-awesome/css/font-awesome.css'
import "../static/css/grid-demo.css"

//全局设置axios
import axios from 'axios'
Vue.prototype.$axios = axios

//设置axios 请求头带token
axios.interceptors.request.use(
  config =>{
    let token = sessionStorage.getItem('token')
    if(token){
        //这里面获取的请求头的键(tokenHeader)根据每个后端的习惯封装的名称各不相同  
      config.headers.common['token'] = token
    }
    return config
  }, error =>{
    return Promise.reject(error)
  }
)

//设置响应如果为403 清除token后跳转到登录页面
axios.interceptors.response.use(
  response => {
      return response;
  },
  error => {
      if (error.response) {
          switch (error.response.status) {
              case 403:
                  // 返回 403清除token信息并跳转到登录页面
                  localStorage.removeItem('islogin')
                  localStorage.removeItem('token')
                  alert("当前会话超时，请重新登入！");
                  window.parent.location.href = "/admin";
          }
      }
      return Promise.reject(error.response.data)   // 返回接口返回的错误信息
  });

// 配置路由权限
// router.beforeEach((to, from, next) => {
//   if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
//     if (localStorage.getItem("islogin")) { // 判断本地是否存在access_token
//       next()
//     } else {
//       // 未登录,跳转到登陆页面，并且带上 将要去的地址，方便登陆后跳转。
//       next({
//         path: '/admin',
//         // query:{ referrer: to.fullPath}
//       })
//     }
//   } else {
//     next()
//   }
// })

//基础配置，设置为false为生产模式
Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js